module.exports = __webpack_public_path__ + "static/img/IMG_20240209_174142.31aefc5d.jpg";